import $ from 'jquery';

export default class BackToTop {
  constructor(el) {
    this.el = el;

    el.addEventListener('click', this.handleClicks);
  }

  handleClicks(event) {
    event.preventDefault();

    $('html, body').animate({ scrollTop: '0' }, 600);
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/BackToTop.js